<template>
  <div>
    <b-tabs v-model="tabIndex">
      <b-tab :title="'Autorizações'">
          <template slot="title">
          <i class="fas fa-dollar-sign text-third"></i><span class="d-md-down-none pl-1 text-third"> Despesas</span>
          </template>
          <div>
          <div v-if="tabIndex === 1"></div>
          <HeadDetailsGama
          :buttonsAccredited="true"
          @time="despesaItemSituacao"
          :btnTime="TempoMaximo"
          :btnNewAdd="dataDetails.situacao === 0 || dataDetails.situacao === 1  ? true : false"
          @add="newDespesa"
          :titleHead="''"
          @voltarPersonalizado="$emit('voltarPersonalizado')"
          :btnBack="true">
          </HeadDetailsGama>
          <div class="mt-4">
              <Tables ref="tableGridExpenseItem"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
                  >
                      <tr v-for="data in dataExpense" :key="data.id">
                          <TableColumn :newState="true" :colorStatus="getColorSituacao(data.situacao)" :descriptionNewStatus="getSituacaoDescription(data.situacao)" />
                          <TableColumn :IsText="true" classCss="text-center" :value="data.despesaTipo.nome" />
                          <TableColumn :IsText="true" classCss="text-center" :value="formatMoney(data.valorTotal)" />
                          <TableColumn :IsText="true" classCss="text-center" :value="data.quantidadeFinal == null ? '0' : data.quantidadeFinal" />
                          <TableColumn :IsText="true" classCss="text-center" :value="formatMoney(data.valorUnitarioFinal)" />
                          <TableColumn :IsText="true" classCss="text-center" :value="formatMoney(data.valorTotalFinal)" />
                          <TableColumn :IsText="true" classCss="text-center" :value="data.observacao == null ? 'N/D' : data.observacao" />
                          <TableColumn  v-if="data.situacao == -1" :IsActionsButtons="data.despesaTipo.forma !== 1 && (dataDetails.situacao === 0 || dataDetails.situacao === 1)" @Edit="editDes(data)" :status="0" :HasDelete="false" :HasChange="true"  :newEditGama="true" />
                          <TableColumn  v-if="data.situacao != -1" :IsActionsButtons="data.despesaTipo.forma !== 1 && (dataDetails.situacao === 0 || dataDetails.situacao === 1)" v-on:Change="onChange(data)" @Edit="editDes(data)" :status="0" :HasDelete="false" :HasChange="true" :newEditGama="true" />
                      </tr>
                      <tr>
                          <td @click="newDespesa" v-if="dataDetails.situacao === 0 || dataDetails.situacao === 1  ? true : false" class="text-center text-third add-table" colspan="8">+ Adicionar Despesa </td>
                      </tr>
                      <tr>
                          <td colspan="4"></td>
                          <td class="title-cal">TOTAL PREVISTO: {{formatMoney(valuePrevisto)}}</td>
                          <td class="title-cal">TOTAL GASTO: {{formatMoney(valueTotalFinal)}}</td>
                          <td class="title-cal">REEMBOLSAR: {{formatMoney(valueReembolso)}}</td>
                          <td class="title-cal">DESCONTAR: {{formatMoney(valueDesconta)}}</td>
                      </tr>
              </Tables>
              <ModalEditDespesas @reloadItems="onLoad" ref="ModalEditDespesas"></ModalEditDespesas>
              <ModalNewDespesas @reloadItem="onLoad" :dataDetails="dataDetails" ref="ModalNewDespesas"></ModalNewDespesas>

            <b-modal
              hide-footer
              centered
              :title="'INATIVAR DESPESA'"
              size="sm"
              ref="history-lote-term"
              id="history-lote">
                <div>
                    <div  class="body-inativa">
                      <i class="icone-pergunta fa fa-question-circle" aria-hidden="true"></i>
                    </div>
                    <div class="header-body">
                        <div class="header-inativa">
                            ATENÇÃO!
                        </div>
                        <div class="texto-inativa">
                            Deseja realmente inativar essa despesa?
                        </div>
                        <div  class="button-corpo">
                          <button  @click="cancel" class="button-cance"> CANCELAR </button>
                          <button @click="reprovaDespesaItem()"   class="button-save" >SALVAR </button>
                        </div>
                    </div>
                </div>
            </b-modal>
          </div>
          </div>
      </b-tab>
      <b-tab  :title="'Autorizações'">
          <template slot="title">
          <i class="fas fa-paperclip text-third" ></i><span class="d-md-down-none pl-1 text-third"> Anexos</span>
          </template>
          <div id="body-term-cus">
            <div v-if="tabIndex === 2"></div>
              <HeadDetailsGama :buttonsAccredited="true"  @dowload="dawnloadGrup" :btnAnexDown="true"  :titleHead="'ANEXOS DE COMPROVANTES'"></HeadDetailsGama>
              <div class="">
                  <div id="card-description-cus">
                      <div class="body-search mt-3">
                          <i class="fas fa-search" id="icon-search"></i>
                          <input v-model="searchFiles" type="text" class="form-control input-search" placeholder="Pesquisar midias">
                      </div>
                      <div class="img-body-all mt-3">
                        <div v-for="arquivo in GetdataAnexos" :key="arquivo.id" class="img-unique mx-4 my-2">
                          <div @click="deleteFile(arquivo.id)" class="remove-img" v-if="dataDetails.situacao == 0 || dataDetails.situacao == 1">X</div>
                          <img class="img-unique-src" @click="openImg($event, arquivo)" v-show="!arquivo.isPdf" :src="'data:image/png;base64,' + arquivo.arquivo" >
                          <i v-show="arquivo.isPdf" @click="openImg($event, arquivo)"  class="fas fa-file-pdf icone-pdf" ></i>
                          <div class="img-unique-footer">{{arquivo.name}}</div>
                        </div>
                        <div v-if="dataDetails.situacao == 0 || dataDetails.situacao == 1 ? true : false" id="dropzone" class="mx-4 my-2" style="border-radius: 10px"
                        @dragenter.prevent.stop="onDragEnter"
                        @dragover.prevent.stop="onDragEnter"
                        @drop.prevent.stop="">
                          <div class="add-img" @click="inputOpen" @dragleave.prevent.stop="onDragLeave" @drop.prevent="sendFile">
                            <i class="fas fa-file-archive"></i>
                          </div>
                        </div>
                        <input @change="sendFile" id="input-" type="file" class="input-hidde">
                      </div>
                  </div>
              </div>
          </div>
      </b-tab>
      <b-tab :title="'Historico de viagem'">
          <template slot="title">
          <i class="fas fa-history text-third" ></i><span class="d-md-down-none pl-1 text-third"> Historico de viagem</span>
          </template>
          <div id="body-term-cus">
            <div v-if="tabIndex === 3"></div>
              <HeadDetailsGama :buttonsAccredited="true"  @dowload="dawnloadGrup"   :titleHead="'ANEXOS DE COMPROVANTES'"></HeadDetailsGama>
              <div class="mt-4">
                <Tables ref="tableGridHistoryDespesa"
                :columns="[
                  'Lote',
                  'Data Solicitação',
                  'Solicitante',
                  'Funcionário',
                  'Função',
                  'Obra',
                  'Responsável',
                  'Regional',
                  'Viagem Motivo',
                  'Viagem Início',
                  'Viagem Fim',
                  'Cidade Origem',
                  'Cidade Destino',
                  'Situação',
                  'Total previsto',
                  'Total',
                ]"
                :messageTipFooter="$lang.Common.ClickToSelect"
                :showPrint="false"
                :showDownload="false"
                :showCheckInput="false"
                v-on:Load="getAllHistory"
              >
                  <tr v-for="(obj, index) in dataDespesaHistory" v-bind:key="index">
                    <!-- <td class="text-center pt-4">
                      <input type="checkbox" :id="obj.id">
                    </td> -->
                    <TableColumn :IsText="true"    v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.lote !== null ? obj.lote : 'N/D'" />
                    <TableColumn :IsDateOnly="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.dataCriacao" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.solicitante.nome" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.favorecido ? obj.favorecido.nome : ''" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.favorecido && obj.favorecido.cargo ? obj.favorecido.cargo.nome : ''" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.responsavel ? obj.responsavel.nome : ''" />
                    <TableColumn :IsText="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status"
                                :value="obj.secaoRH.nome" />
                    <TableColumn :IsText="true"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
                    <TableColumn :IsDateOnly="true"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
                    <TableColumn :IsDateOnly="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemFim" />
                    <TableColumn :IsText="true"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.origem)" />
                    <TableColumn :IsText="true"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.destino)" />
                    <TableColumn :IsCustom="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status">
                      <b-badge  v-if="obj.situacao !== 2 && obj.situacao < 4 && obj.situacao >= 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
                      <b-badge  v-else-if="obj.situacao < 0" variant="danger" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
                      <b-badge  v-else-if="obj.situacao >= 4 || obj.situacao === 2" variant="success" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
                    </TableColumn>
                    <TableColumn :IsCustom="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status">
                      <strong >{{formatMoney(obj.valorSolicitado)}}</strong>
                    </TableColumn>
                    <TableColumn :IsCustom="true"
                                v-on:Edit="onEdit(obj)"
                                :status="obj.status">
                      <strong :style="obj.valorTotal >= 0 ?  'color: red' :   'color: #004987'">{{formatMoney( -1 * obj.valorTotal)}}</strong>
                    </TableColumn>
                  </tr>
                </Tables>
              </div>
          </div>
      </b-tab>
      <b-tab :title="'Log'">
          <template slot="title">
              <i class="fas fa-tasks text-third"></i><span class="d-md-down none pl-1 text-third text-tabs"> Log </span>
          </template>
          <div class="painel-detalhes-main" id="body-term">
              <HeadDetailsGama :buttonsAccredited="true" :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4" :titleHead="'Log de Status'"></HeadDetailsGama>
              <div id="body-details">
                  <div id="head-details" class="pt-2">
                      <div class="w-25 input-rela icon-adjustment">
                          <input placeholder="Pesquisar log" class="form-control input-paddi w-100 h-100" v-model="serachiput" >
                          <i aria-hidden="true" class="fas fa-search icon-search"></i>
                      </div>
                  </div>
              </div>
              <div id="body-details">
              <div id="tablog" class="mt-4 ml-2">
              <div v-if="serachiput.length == ''">
                  <div v-for="(data,index) in logAccountability" :key="data.id">
                      <div class="d-flex flex-row mt-1 ml-2" style="font-family:'Segoe UI'">
                          <div class="linhaAling">
                              <div class="ballCrzy">
                                  <div class="textNum">{{data.diaFormatada}}</div>
                                  <div class="textNum">{{mostrarNomeMes(data.mesFormatada)}}</div>
                              </div>
                              <div class="linhaSolid"></div>
                          </div>
                          <div class ="ml-3 mt-3">
                              <div class="squareCrzy">
                                  <div class="Textneg"> {{data.titulo}} </div>
                                  <div class="Textneg2">
                                      <div class="description-log">
                                          <i class="fas fa-user-circle" style="scale: 1.25" ></i>{{data.nomeConta != null ? data.nomeConta : 'N/D'}}
                                      </div>
                                      <div class="description-log">
                                          <i class="far fa-clock" style="scale: 1.25"></i>{{data.dataFormatada}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div v-if="index == logAccountability.length -1">
                          <div class="d-flex flex-row mt-1 ml-2">
                              <div class="linhaAling">
                                  <div class="ballCrzy">
                                      <div class="fas fa-check ballCrzyDone"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                      <div v-if="logAccountability.length < 1" class="d-flex flex-row mt-1 ml-2">
                          <div class="d-flex align-items-center w-100 h-100 flex-row mt-1" style="font-family:'Segoe UI'">
                              <div class="linhaAling mr-3">
                                  <div class="ballCrzy">
                                      <div class="fas fa-question ballCrzyDone"></div>
                                  </div>
                                  <!-- <div class="linhaSolid"></div> -->
                              </div>
                              <!-- <div class ="ml-3 mt-3">
                                  <div class="squareCrzy"> -->
                                      <div class="Textneg"> Nenhum registro de log foi encontrado! </div>
                                  <!-- </div>
                                  </div> -->
                          </div>
                      </div>
                  <!-- <div v-if="data.length !== null || serachiput.length !== 0" class="d-flex align-items-center flex-row mt-1 ml-2 w-100 h-100">
                      <div class="linhaAling">
                          <div class="ballCrzy">
                              <div class="fas fa-check ballCrzyDone"></div>
                          </div>
                      </div>
                  </div> -->
                  </div>
              </div>
          </div>
              <!-- <logAdvance :buttonsAccredited="true" @setSing="setSing" :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4"  ref="logAdvance"></logAdvance> -->
          </div>
      </b-tab>
    </b-tabs>
    <div id="myModal" class="modal" >

        <!-- The Close Button -->
        <span class="close">&times;</span>

        <!-- Modal Content (The Image) -->
        <img v-show="!isPdf" class="modal-content" id="img01">

         <iframe
            style="overflow: hidden"
            id="pdfViewer"
            scrolling="no"
            v-show="isPdf"
            class="mb-2 img-body-body pdf-overview"
            :src="'data:application/pdf;base64,'+ dataBase64Pdf + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
          </iframe>

        <!-- Modal Caption (Image Text) -->
        <div id="caption"></div>
    </div>
  </div>
  </template>

<script>
import FormDetailsComission from './FormDetailsComission'
export default FormDetailsComission
</script>

  <style scoped>
  .texto-inativa{
    display: flex;
    text-align: center;
    font-size: 15px;
  }
  .button-cance{
     outline: transparent;
     border: transparent;
     border-radius: 4px;
     text-transform: uppercase;
     width: 190px;
     height: 40px;
     background-color: #aa1414;
     color: white;
  }
  .button-save{
     outline: transparent;
     border: transparent;
     border-radius: 4px;
     text-transform: uppercase;
     width: 190px;
     height: 40px;
     background-color: #008148;
     color: white;
  }
  .button-corpo{
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1rem;
  }
  .header-inativa{
    font-size: 23px;
    color: #797878;
    font-weight: bold;
    display: flex;
    justify-content: center;
    margin: 1rem;
  }
  .body-inativa{
    display: flex;
    justify-content: center;
  }
  .icone-pergunta{
    font-size: 60px;
    color:#008144
  }
  .img-unique-src{
      height: 100%;
      cursor: pointer;
      width: 100%;
      border-radius: 10px;
  }
  .body-search{
      position: relative;
  }
  #icon-search{
      position: absolute;
      top: 8px;
      left: 5px;
      font-size: 16px;
  }
  .add-table{
      cursor: pointer;
      font-weight: bold;
  }
  .title-cal{
    font-weight: bold;
  }

  .input-search{
      width: 30%;
      padding-left: 25px;
  }
  #body-term, #card-description{
    height: 100% !important;
  }

  .input-hidde{
      visibility: hidden;
  }
  #dropzone{
    width: 250px;
    height: 200px;
  }
  .add-img{
      width: 100%;
      height: 100%;
      border: 1px dashed black;
      border-radius: 10px;
      display: flex;
      font-size: 50px;
      color: black;
      cursor: pointer;
      justify-content: center;
      align-items: center;
  }
  .icone-pdf{
    font-size: 70px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .img-body-body{
    width: 100%;
    height: 100vh;
  }
  .img-body-all{
      display: flex;
      flex-wrap: wrap;
      padding-left: 2px;
      margin-top: 15px;
  }
  .img-unique{
      width: 250px;
      transition: 500ms;
      position: relative;
      border-radius: 10px;
      height: 200px;
      border: 1px solid rgb(196, 196, 196);
  }
  .img-unique:hover {
    transform: scale(1.1);
  }
  .add-new-arq{
    height: 49px;
    position: absolute;
    z-index: 10;
    top: 1px;
    display: flex;
    font-weight: bold;
    color: white;
    align-items: center;
    justify-content: center;
    border-radius: 0 10px 0 0;
    right: 0;
    width: 50px;
    font-size: 28px;
    cursor: pointer;
    background: #00552d;
  }
  .remove-img:hover{
      background: rgb(196, 1, 1);
  }
  .remove-img{
      position: absolute;
      border-radius: 0 10px 0 50%;
      top: 0;
      right: 0;
      height: 40px;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      background: red;
      color: white;
  }
  .body-all-collapse{
    position: relative;
  }
  #body-term{
    height: 80vh;
    overflow-y: auto;
  }
  .img-unique-footer{
      position: absolute;
      bottom: 0;
      border-radius: 0 0 10px 10px;
      height: 25px;
      background: rgba(0, 0, 0, 0.63);
      display: flex;
      justify-content: center;
      font-weight: bold;
      width: 100%;
      align-items: center;
      color: white;
  }

  /* estilização do cabeçalho do popup */

  .container-hearder{
    background-color: #008144;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    align-items: center;
    padding: 25px 0;
  }

  .title-hearder{
    color: white;
    grid-column: 1;
    grid-row: 1;
    text-transform: uppercase;
    justify-self: center;
  }

  .container-close-button{
    grid-column: 1;
    grid-row: 1;
    justify-self: end;
    align-self: center;
  }

  .container-close-button img{
    width: 32px;
  }

  .img-modal-details{
    height: 400px;
    object-fit: cover;
    width: 100%;
  }
  /* Style the Image Used to Trigger the Modal */
  #myImg {
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }

  #myImg:hover {opacity: 0.7;}

  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 100000; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  }

  /* Modal Content (Image) */
  .modal-content {
    margin: auto;
    margin-top: 1%;
    display: block;
    width: 80%;
    max-width: 700px;
  }
  .buttonImage[data-v-3164f3a8] {
      position: absolute;
      color: black;
      border: none;
      width: 15px;
      font-weight: bold;
      z-index: -1;
      right: 7%;
      top: 15px;
      height: 15px;
      font-size: 17px;
      border-radius: 6px;
  }

  .breadcrumb[data-v-5806b3d1] {
      position: fixed;
      width: 100%;
      z-index: -1;
  }

  /* Caption of Modal Image (Image Text) - Same Width as the Image */
  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
  }

  /* Add Animation - Zoom in the Modal */
  .modal-content, #caption {
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  #greenChange {
      color: #008148;
  }

  .ballCrzy {
      width: 50px;
      height: 50px;
      border-radius:50%;
      border: 3px solid;
      font-size: 16px;
  }

  .ballCrzyDone {
      display: flex;
      justify-content: center;
      padding-top: 13px;
      font-size: 20px;
  }

  .squareCrzy {
      width: 520px;
      height: 130px;
      background: rgb(243, 241, 241);
      border-radius:1px 15px 15px;
      color: #111;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 1rem 1rem 1rem 2rem;
      box-shadow: 10px 10px 5px 0px #d2d2d2;
      font-family: 'Segoe UI';
      display: flex;
      justify-content: space-between;
  }

  .textNum{
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .Textneg2 {
      font-size: 12px;
      color:rgb(116, 121, 116);
      font-family:'Segoe UI';
      font-weight: bold;
      display: flex;
      flex-direction: column;
  }

  .Textneg {
      font-weight: bold;
      font-size: 16px;
      color:#008148;
  }

  .linhaSolid {
      height: 125px;
      border-left: 2px solid;
  }

  .icon-adjustment {
      display: flex;
      flex-direction: row-reverse;
      align-items: baseline;
      border: 1px solid #ced4da;
      padding-left: 5px;
  }

  .form-control{
      display: block;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px none;
      border-radius: 0;
      padding-left: 5px;
  }

  .linhaAling{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 3px;
      color: #008148;
  }

  #tablog{
      height: 100%;
  }

  .description-log {
      display: flex;
      gap: 1rem;
      font-family:'Segoe UI';
      align-items: center;
  }

  @keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
  }
  /* The Close Button */
  .close {
    position: absolute;
    top: 12px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px){
    .modal-content {
      width: 100%;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/FormDetailsComission/FormDetailsComission.vue